module.exports = __webpack_public_path__ + "img/phone.30d14d2d.png";